import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import store from '@/store'
import Swal from 'sweetalert2/dist/sweetalert2'

const { cookies } = useCookies()
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

axios.interceptors.request.use(
  (config) => {
    const data = cookies.get('accessToken')
    if (data == null) {
      return config
    }
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers.Authorization = data

    return config
  },
  (err) => {
    console.log(err)
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  (res) => {
    return Promise.resolve(res)
  },
  (err) => {
    if (!err.response) {
      Swal.fire({
        title: '알림',
        html: '네트워크에 접속할 수 없습니다. <br>Wi-Fi 또는 데이터를 활성화 해주세요.',
        showConfirmButton: true,
        confirmButtonText: '확인',
        showCancelButton: false,
        allowOutsideClick: false,
        customClass: {
          title: 'outTitle',
          htmlContainer: 'outText',
        },
      })
    }
    switch (err.response.status) {
      case 400:
        Swal.fire({
          title: '알림',
          text: '잘못된 요청입니다.',
          showConfirmButton: true,
          confirmButtonText: '확인',
          showCancelButton: false,
          allowOutsideClick: false,
          customClass: {
            title: 'outTitle',
            htmlContainer: 'outText',
          },
        })
        break
     
      case 403:
        store.dispatch('logout')
        Swal.fire({
          title: '로그아웃',
          html: '로그인 기간 만료로 인해 로그아웃 됩니다.',
          showConfirmButton: true,
          confirmButtonText: '확인',
          showCancelButton: false,
          allowOutsideClick: false,
          customClass: {
            title: 'outTitle',
            htmlContainer: 'outText',
          },
        })
        break

      case 401:
        store.dispatch('logout')
        Swal.fire({
          title: '로그아웃',
          html: '로그인 기간 만료로 인해 로그아웃 됩니다.',
          showConfirmButton: true,
          confirmButtonText: '확인',
          showCancelButton: false,
          allowOutsideClick: false,
          customClass: {
            title: 'outTitle',
            htmlContainer: 'outText',
          },
        })
        break  

      default:
        break
    }

    return Promise.reject(err)
  }
)
export default axios
